<template>
  <v-layout row wrap class="pcs-view">
    <v-flex xs12 v-if="loading">
      <v-progress-linear indeterminate color="primary" height="2"></v-progress-linear>
    </v-flex>
    <v-flex xs12 v-show="!loading">
      <v-layout row wrap>
        <v-flex
          xs6
          sm4
          v-for="item in headerItems"
          :key="item.key"
        >
          <Card style="height: 75px">
            <v-flex class="text-xs-center inner-card">
              <div class="font-weight-bold headline">
                <span
                  :class="
                    item.value == 'N/A' || item.value == 'No Data'
                      ? 'error--text'
                      : 'number--text'
                  "
                  class="mr-1"
                  >{{ item.value }}</span
                >
                <span
                  v-if="item.value != 'No Data'"
                  class="caption extraGrey--text unit"
                  >{{ item.unit }}</span
                >
              </div>
              <div class="body-1 extraGrey--text">{{ $t(item.name) }}</div>
            </v-flex>
          </Card>
        </v-flex>
        <v-flex xs12 v-if="pcsHeaderItems && pcsHeaderItems.length > 5">
          <v-carousel
            hide-delimiters
            :hide-controls="groupedPcsHeaderItems.length <= 1"
            height="75px"
            :cycle="false"
            class="transparent-carousel"
          >
            <v-carousel-item v-for="(itms, index) in groupedPcsHeaderItems" :key="index">
              <v-layout row wrap>
                <v-flex
                  style="width: 20%"
                  class="pa-1"
                  v-for="item in itms"
                  :key="item.key"
                >
                  <Card style="height: 75px">
                    <v-flex class="text-xs-center inner-card">
                      <div class="font-weight-bold headline">
                        <span
                          :class="
                            item.value == null ? 'error--text' : 'number--text'
                          "
                          class="mr-1"
                          >{{ item.value == null ? "N/A" : item.value }}</span
                        >
                        <span
                          v-if="item.value != 'No Data'"
                          class="caption extraGrey--text unit"
                          >{{ item.unit }}</span
                        >
                      </div>
                      <div class="body-1 extraGrey--text">{{ $t(item.name) }}</div>
                    </v-flex>
                  </Card>
                </v-flex>
              </v-layout>
            </v-carousel-item>
          </v-carousel>
        </v-flex>

        <v-flex
          v-else-if="pcsHeaderItems && pcsHeaderItems.length > 0"
          style="width: 20%"
          v-for="item in pcsHeaderItems"
          :key="item.key"
        >
          <Card style="height: 85px">
            <v-flex class="text-xs-center inner-card">
              <div class="font-weight-bold headline">
                <span
                  :class="item.value == null ? 'error--text' : 'number--text'"
                  class="mr-1"
                  >{{ item.value == null ? "N/A" : item.value }}</span
                >
                <span
                  v-if="item.value != 'No Data'"
                  class="caption extraGrey--text unit"
                  >{{ item.unit }}</span
                >
              </div>
              <div class="body-1 extraGrey--text">{{ $t(item.name) }}</div>
            </v-flex>
          </Card>
        </v-flex>
      </v-layout>
    </v-flex>

    <v-flex xs12 md9 v-if="fullDate">
      <Graph :fullDate="fullDate" :selectedPcsId="blockId" @loading="(val) => (loading = val)" />
    </v-flex>
    <v-flex xs12 md3>
      <SideCard
        @activeBlock="(val) => (blockId = val)"
        @pcsList="(val) => (pcsList = val)"
        @pcs-live-data="headerItemsHandler"
        @loading="(val) => (loading = val)"
      />
    </v-flex>
  </v-layout>
</template>

<script>
const moment = require('moment')
const momentTz = require('moment-timezone')
import { mapGetters, mapMutations } from "vuex";
import { mixin, mapGettersMixin } from "@/util/mixin/index";

const Graph = () => import("@/components/dashboard-pcs/Graph");
const SideCard = () => import("@/components/dashboard-pcs/SideCard");

export default {
  props: {
    changesFromFilter: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  mixins: [mixin, mapGettersMixin],
  components: {
    Graph,
    SideCard,
  },
  data() {
    return {
      filter: [
        {
          id: "Date",
          type: "singleDatePicker",
          title: "Date",
        },
      ],
      activeFilter: {},
      blockId: null,
      pcsList: [],
      headerItems: [
        {
          name: "Meter Generation",
          value: "N/A",
          unit: "kWh",
        },
      ],
      pcsHeaderItems: [],
      loading: true,
    };
  },
  computed: {
    ...mapGetters(["getActivePlantTimezone"]),
    fullDate() {
      return this.activeFilter.Date ? [this.activeFilter.Date.from, this.activeFilter.Date.to] : ['', '']
    },
    groupedPcsHeaderItems() {
      return this.groupArray(this.pcsHeaderItems, 5);
    },
  },
  created() {
    this.m2mNameMap = {
      grid_phvlt_1: { name: "Grid PhVlt 1", unit: "V" },
      grid_phvlt_2: { name: "Grid PhVlt 2", unit: "V" },
      grid_phvlt_3: { name: "Grid PhVlt 3", unit: "V" },
      pcs_phvlt_1: { name: "PCS PhVlt 1", unit: "V" },
      pcs_phvlt_2: { name: "PCS PhVlt 2", unit: "V" },
      pcs_phvlt_3: { name: "PCS PhVlt 3", unit: "V" },
      actv_pwr_1: { name: "Actv Pwr 1", unit: "kW" },
      actv_pwr_2: { name: "Actv Pwr 2", unit: "kW" },
      actv_pwr_3: { name: "Actv Pwr 3", unit: "kW" },
      reactv_pwr_1: { name: "Reactv Pwr 1", unit: "kVAR" },
      reactv_pwr_2: { name: "Reactv Pwr 2", unit: "kVAR" },
      reactv_pwr_3: { name: "Reactv Pwr 3", unit: "kVAR" },
      aprt_pwr_1: { name: "Aprt Pwr 1", unit: "kVA" },
      aprt_pwr_2: { name: "Aprt Pwr 2", unit: "kVA" },
      aprt_pwr_3: { name: "Aprt Pwr 3", unit: "kVA" },
    };
  },
  mounted() {
    const Obj = {}
    const cloneFilterOption = _.cloneDeep(this.filter);
    cloneFilterOption.forEach(child => {
      if (child.type === 'singleDatePicker') {
        let parameters = ['from', 'to']
        parameters.forEach(key => {
          if (!Obj[child.id]) { Obj[child.id] = {} }
          Obj[child.id][key] = momentTz().tz(this.getActivePlantTimezone).format('YYYY-MM-DD')
        })
      }
    })
    this.activeFilter = Obj;
    this.$emit("filter:config", cloneFilterOption);
    this.$emit('initial:active_filter', Obj)
    this.SET_PROGRESS_BAR(true);
  },
  destroyed() {
    this.SET_PROGRESS_BAR(false);
  },
  methods: {
    ...mapMutations(["SET_PROGRESS_BAR"]),
    groupArray(array, groupSize) {
      const groupedArray = [];
      for (let i = 0; i < array.length; i += groupSize) {
        groupedArray.push(array.slice(i, i + groupSize));
      }
      return groupedArray;
    },
    headerItemsHandler(value) {
      if (!value) return;
      
      const pcsHeaderItems = [];
      const headerItems = [
        {
          name: "Meter Generation",
          value: "N/A",
          unit: "kWh",
          key: "meter_gen",
        },
      ];
      
      headerItems.push({
        name: "PCS Ambient Temperature",
        value: value.amb_temp == null ? "N/A" : value.amb_temp,
        unit: "°C",
        key: 'amb_temp'
      });
      headerItems.push({
        name: "PCS Global State",
        value: value.global_state == null ? "N/A" : value.global_state,
        unit: "",
        key: 'global_state'
      });

      for (const [key, val] of Object.entries(this.m2mNameMap)) {
        if (value[key] !== undefined) {
          pcsHeaderItems.push({
            name: val.name,
            value: value[key],
            unit: val.unit,
            key: key
          });
        }
      }

      // Only update if changed to avoid unnecessary re-renders (basic check)
      if (this.pcsHeaderItems.length !== pcsHeaderItems.length || JSON.stringify(this.pcsHeaderItems) !== JSON.stringify(pcsHeaderItems)) {
        this.pcsHeaderItems = Object.freeze(pcsHeaderItems);
      }
      this.headerItems = headerItems;
    },
  },
  watch: {
    changesFromFilter: {
      handler(val) {
        this.activeFilter = val;
      },
      deep: true,
    }
  }
};
</script>

<style scoped>
@media (max-width: 600px) {
  .pa-2 {
    padding: 0px !important;
  }
}

.main-background {
  background-color: #2a335a;
}

.theme--dark {
  width: -webkit-fill-available;
}

@media only screen and (min-width: 768px) and (max-width: 992px) {
  .v-card {
    width: 200px !important;
  }
}

.pcs-view {
  min-height: 400px;
}

.transparent-carousel {
  border: none;
  box-shadow: none;
}

.inner-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
}
</style>